export default "__VITE_ASSET__C3lCtloJ__"